/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/prefer-tag-over-role */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';

// assets
import iconCloseX from '../../../assets/img/icon-close-x.svg';
import './modal.css';

let __modalIdCounter = 0;
const nextDeterministicId = (prefix = 'modal') => {
  __modalIdCounter += 1;
  return `${prefix}-${__modalIdCounter}`;
};
/* istanbul ignore next */
const Modal = ({
  id,               
  children,
  isOpen,
  closeModal,
  unableToClose,
  closeEscKey = true,
  closeClickOutside = true,
  className = '',
  labelledById,      
  describedById,
}) => {
  const stableIdRef = useRef(id || nextDeterministicId('modal'));
  const modalId = stableIdRef.current;
  const dialogRef = useRef(null);
 /* istanbul ignore next */
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (e) => {
      if ((e.key === 'Escape' || e.keyCode === 27) && !unableToClose && closeEscKey) {
        closeModal();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [isOpen]);
  /* istanbul ignore next */
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget && !unableToClose && closeClickOutside) {
      closeModal();
    }
  };
  /* istanbul ignore next */
  const handleBackdropKeyDown = (e) => {
    if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      if (!unableToClose && closeClickOutside) {
        closeModal();
      }
    }
  };
  /* istanbul ignore next */
  return (
    <div
      className={`${className} modal-container ${isOpen ? 'modal-container--is-open' : ''}`}
      onClick={handleBackdropClick}
      onKeyDown={handleBackdropKeyDown}
      aria-hidden={!isOpen}
    >
      <div
        ref={dialogRef}
        className="modal-content"
        id={modalId}
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledById}
        aria-describedby={describedById}
      >
        {!unableToClose && (
          <button
            type="button"
            className="modal-close"
            onClick={closeModal}
            aria-label="Cerrar modal"
          >
            <img src={iconCloseX} alt="" width="14" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;